import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import BaseActionForm from '../BaseActionForm';
import { Button, Dropdown } from "react-bootstrap";
import './styles.scss'
import RangeSlider from 'react-bootstrap-range-slider';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import DropdownWithFilter from './../../components/DropdownWithFilter';
import { Tooltip } from 'react-tooltip'
import LeftPanelHeader from './../../components/LeftPanelHeader';

import { checkActiveProcess } from '../../utils/ProcessFunctions.js';
import * as actionTypes from "../../services/StoreContainer/actionTypes";
import { selectDataset, updateMyDatasets } from "./../../services/StoreContainer/actionCreators";

export default function Connector(props) {
    const dispatch = useDispatch();
    const datasetsContainer = useSelector((store) => { return store.datasetsReducer })

    const [taskState, setTaskState] = useState({ state: "", progress: 0, progressUpdate: false });

    useEffect(() => {
        if (datasetsContainer && datasetsContainer.selectedDataset.runningTasks.length) {
            const task = datasetsContainer.selectedDataset.runningTasks.find(task => task.performer === "lk_connector")
            if (task) {
                console.log(task, task.lastInfo.progress)
                let newTaskState = { state: "", progress: task.lastInfo.progress, progressUpdate: false };

                if ((taskState.state === "" || taskState.state === "running") && !task.lastInfo.completed)
                    newTaskState = {
                        state: "running",
                        progress: task.lastInfo.progress !== taskState.progress ? task.lastInfo.progress : taskState.progress,
                        progressUpdate: task.lastInfo.progress !== taskState.progress
                    };

                if (taskState.state === "" && task.lastInfo.completed)
                    newTaskState = {
                        state: "running",
                        progress: "finish",
                        progressUpdate: true
                    };

                setTaskState(newTaskState);
            }
        }
        else {
            if (taskState.state === "running") setTaskState({ state: "finish", progress: 1, progressUpdate: true })
        }
        //eslint-disable-next-line
    }, [datasetsContainer.selectedDataset.runningTasks])


    return <ConnectorClass
        {...props}
        dispatch={dispatch}
        datasetsContainer={datasetsContainer}
        progressBar={<>
            <p className={'infoProcesses2'} style={{ display: 'inline' }}>
                Дождитесь завершения запущенных процессов
                {taskState && taskState.progress
                    ? ": пройдено " + Math.round(taskState.progress * 100) + "%"
                    : (taskState.state === "finish" ? ": пройдено 100%. Можно закрыть данное окно" : ": пройдено 0%")}
            </p>
        </>}
    />
}
class ConnectorClass extends BaseActionForm {

    SAMPLES_PORTION_SIZE = 5;

    RESULT_QUALITY_GROUPS = {
        normal: {
            label: "точные связи",
            defaultTreshold: 0.9,
            filter: {
                "__connection.GlobalID": {
                    '$ne': null
                },
                "__connection.ID2NoGeom": null
            },
            weightField: "weight",
            connectedAddressFields: ["Municipalitet", "Street", "HouseNumber"]
        },
        inaccurate: {
            label: "неточные, но с геометрией",
            defaultTreshold: 0.7,
            filter: {
                "__connection.ID2NoGeom": {
                    '$ne': null
                }
            },
            weightField: "weight",
            connectedAddressFields: ["Municipalitet", "Street", "HouseNumber"]
        },
        street: {
            label: "до улицы",
            defaultTreshold: 0.9,
            filter: (normalTreshold, inaccurateTreshold, streetTreshold) => {
                return {
                    '$or': [
                        { "__connection.GlobalID": null },
                        {
                            "__connection.GlobalID": {
                                '$ne': null
                            },
                            "__connection.ID2NoGeom": null,
                            "__connection.weight": { "$lte": normalTreshold }
                        },
                        {
                            "__connection.ID2NoGeom": {
                                '$ne': null
                            },
                            "__connection.weight": { "$lte": inaccurateTreshold }
                        }
                    ],
                    "__connection.approxStreet": {
                        '$ne': null
                    }
                }
            },
            weightField: "approxStreetWeight",
            connectedAddressFields: ["approxMunicipalitet", "approxStreet"]
        },
        municipalitet: {
            label: "до населенного пункта",
            defaultTreshold: 0.9,
            filter: (normalTreshold, inaccurateTreshold, streetTreshold) => {
                return {
                    "$and": [
                        {
                            "$or": [
                                {
                                    "__connection.GlobalID": null
                                },
                                {
                                    "__connection.GlobalID": {
                                        "$ne": null
                                    },
                                    "__connection.ID2NoGeom": null,
                                    "__connection.weight": {
                                        "$lte": normalTreshold
                                    }
                                },
                                {
                                    "__connection.ID2NoGeom": {
                                        "$ne": null
                                    },
                                    "__connection.weight": {
                                        "$lte": inaccurateTreshold
                                    }
                                }
                            ]
                        },
                        {
                            "$or": [
                                {
                                    "__connection.approxStreet": null
                                },
                                {
                                    "__connection.approxStreetWeight": {
                                        "$lte": streetTreshold
                                    }
                                }
                            ]
                        },
                        {
                            "__connection.approxMunicipalitet": {
                                "$ne": null
                            }
                        }
                    ]
                }
            },
            weightField: "approxMunicipalitetWeight",
            connectedAddressFields: ["approxMunicipalitet"]
        }
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dataset: null,
            regionState: [],
            selectedRegion: null,
            activeProcess: null,
            buttonJustPressed: false,
            version: null,
            crossType: null,
            partsName: null,
            filterOfPart: null,
            connectionStage: null,
            checkingResults: null,
            fieldsForGeocoding: []
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        this.startLoading();
        let regionState = await this.generalApi.getObjects("rk_metadata", "regionState", { sortBy: "region", sortOrder: "asc", projection: { database: 1, region: 1 } });
        this.stopLoading();


        let dataset = this.props.datasetsContainer.selectedDataset;

        this.setState({
            dataset: dataset,
            regionState: regionState,
        }, () => {
            if (dataset.connect && dataset.connect.dataset && dataset.connect.database) {
                this.lkApi.getToken(dataset.connect.dataset, { database: dataset.connect.database })
                    .then((response) => {
                        this.setState({
                            token: response.token
                        }, () => {
                            this.initForDataset(dataset);
                        });
                    });
            }
            else {
                this.initForDataset(dataset);
            }
        });

    }

    // shouldComponentUpdate() {
    //     if (this.props.taskState.state === "running" || this.props.taskState.state === "finish") return this.props.taskState.progressUpdate
    //     return true
    // }

    // componentWillUpdate() {
    //     if (this.props.taskState.state === "running" || this.props.taskState.state === "finish")
    //         this.updateAndCheckDataset(this.props.datasetsContainer.selectedDataset)
    // }


    initForDataset = (dataset) => {
        let connectionStage = dataset.connect && dataset.connect.stage ? dataset.connect.stage : "newconnection";

        let newState = {
            dataset: dataset,
            connectionStage: connectionStage
        };

        let addressField = this.getFieldByFeature(dataset, "Address");
        let regionField = this.getFieldByFeature(dataset, "Region");
        let municipalitetField = this.getFieldByFeature(dataset, "Municipalitet");
        let streetField = this.getFieldByFeature(dataset, "Street");
        let houseNumberField = this.getFieldByFeature(dataset, "HouseNumber");
        let cadNumberField = this.getFieldByFeature(dataset, "CadNumber");
        let geometryField = this.getFieldByFeature(dataset, "Geometry");

        if (regionField && dataset.state) {
            if (dataset.state.fieldsQuality && dataset.state.fieldsQuality[regionField.name]) {
                if (dataset.state.fieldsQuality[regionField.name].oneValue) {
                    newState.oneRegionValue = true;
                    let selectedRegion = null;
                    this.state.regionState && this.state.regionState.forEach((region) => {
                        if (region.database === dataset.state.fieldsQuality[regionField.name].database) {
                            selectedRegion = region;
                        }
                    });
                    if (selectedRegion) {
                        newState.selectedRegion = selectedRegion;
                        newState.detectedRegionName = selectedRegion.region;
                    }
                }
            }
        }

        if (municipalitetField && dataset.state) {
            if (dataset.state.fieldsQuality && dataset.state.fieldsQuality[municipalitetField.name]) {
                if (dataset.state.fieldsQuality[municipalitetField.name].oneValue) {
                    newState.oneMunicipalitetValue = true;
                    newState.detectedMunicipalitetName = dataset.state.fieldsQuality[municipalitetField.name].municipalitetName;
                }
            }
        }

        newState.comments = [];

        if (dataset.state && dataset.state.properties) {
            if (/*dataset.state.properties.has_geometry*/ geometryField && (dataset.state.fieldsQuality[geometryField.name].fullness > 0.7)) {
                newState.version = "v7";
                newState.crossType = "BY_CENTERS";
                newState.partsName = "blocks";

                newState.comments.push("У набора данных хорошие геометрические признаки.");
                if (geometryField) {
                    newState.comments.push("Геометрия заполнена у " + Math.round(dataset.state.fieldsQuality[geometryField.name].fullness * 100) + "% записей.");
                }
                newState.comments.push("Будем применять алгоритм связывания по геометрии с дроблением по блокам.");
            }
            else

                if (true || dataset.state.properties.has_address || dataset.state.properties.has_address_features) {

                    newState.version = "v5";
                    newState.crossType = "BY_SUPERTAGS";

                    let fieldsForGeocoding = [];
                    if (addressField) {
                        fieldsForGeocoding.push(addressField.name);
                    } else {
                        [municipalitetField, streetField, houseNumberField].forEach(field => {
                            if (field) {
                                fieldsForGeocoding.push(field.name);
                            }
                        })
                    }
                    newState.fieldsForGeocoding = fieldsForGeocoding;

                    newState.comments.push("У набора данных есть адресные признаки.");

                    if (newState.oneRegionValue) {
                        newState.comments.push("Похоже, что весь набор данных из одного региона" + (newState.detectedRegionName ? ': ' + newState.detectedRegionName : ''));
                    }
                    else {
                        if (regionField) {
                            newState.comments.push("Регион заполнен у " + Math.round(dataset.state.fieldsQuality[regionField.name].fullness * 100) + "% записей.");
                        }
                    }
                    if (municipalitetField) {
                        newState.comments.push("Населенный пункт заполнен у " + Math.round(dataset.state.fieldsQuality[municipalitetField.name].fullness * 100) + "% записей.");
                    }
                    if (streetField) {
                        newState.comments.push("Улица заполнена у " + Math.round(dataset.state.fieldsQuality[streetField.name].fullness * 100) + "% записей.");
                    }
                    if (houseNumberField) {
                        newState.comments.push("Номер дома заполнен у " + Math.round(dataset.state.fieldsQuality[houseNumberField.name].fullness * 100) + "% записей.");
                    }

                    newState.comments.push("Будем применять алгоритм связывания по адресу.");

                    newState.comments.push("Это не обязательно, но если выберите регион - связывание пойдет быстрее.");

                    /*
                    if (dataset.state.properties.has_address) {
                        newState.version = "v4";
                        newState.crossType = "BY_HIERARHY";
                        newState.partsName = "blocks";

                        newState.comments.push("У набора данных хорошие адресные признаки.");
                        if (newState.oneRegionValue) {
                            newState.comments.push("Похоже, что весь набор данных из одного региона" + (newState.detectedRegionName ? ': ' + newState.detectedRegionName : ''));
                        }
                        else {
                            if (regionField) {
                                newState.comments.push("Регион заполнен у " + Math.round(dataset.state.fieldsQuality[regionField.name].fullness * 100) + "% записей.");
                            }
                        }
                        if (newState.oneMunicipalitetValue) {
                            newState.comments.push("А еще похоже, что весь набор данных из одного населенного пункта" + (newState.detectedMunicipalitetName ? ': ' + newState.detectedMunicipalitetName : ''));
                        }
                        else {
                            if (municipalitetField) {
                                newState.comments.push("Населенный пункт заполнен у " + Math.round(dataset.state.fieldsQuality[municipalitetField.name].fullness * 100) + "% записей.");
                            }
                        }
                        if (streetField) {
                            newState.comments.push("Улица заполнена у " + Math.round(dataset.state.fieldsQuality[streetField.name].fullness * 100) + "% записей.");
                        }
                        if (houseNumberField) {
                            newState.comments.push("Номер дома заполнен у " + Math.round(dataset.state.fieldsQuality[houseNumberField.name].fullness * 100) + "% записей.");
                        }
                        newState.comments.push("Будем применять алгоритм связывания по иерархии с дроблением по блокам.");
                    } else
                        if (cadNumberField && dataset.state && dataset.state.fieldsQuality &&
                            dataset.state.fieldsQuality[cadNumberField.name] &&
                            (dataset.state.fieldsQuality[cadNumberField.name].fullness > 0.9) &&
                            (dataset.state.fieldsQuality[cadNumberField.name].entropy > 0.3)) {

                            newState.version = "v4";
                            newState.crossType = "BY_FULLADDRESS";
                            newState.partsName = "quarters";

                            newState.comments.push("У набора есть кадастровый номер, будем применять алгоритм связывания по полному адресу с дроблением по кадастровым кварталам.");
                        }
                        else {
                            newState.version = "v4";
                            newState.crossType = "BY_FULLADDRESS";
                            newState.partsName = "blocks";

                            newState.comments.push("У набора не особенно хорошие адресные признаки, будем применять алгоритм связывания по полному адресу с дроблением по блокам.");
                        }
                    */


                }
                else {
                    newState.comments.push("У набора недостаточно признаков места, чтобы попытаться связать его.");
                    if (dataset.state.properties.has_geometry_features) {
                        newState.comments.push("При этом есть поля, похожие на геометрию. Попробуйте обработать геометрию и добавить такой признак.");
                    }
                    else
                        if (dataset.state.properties.has_geometry_features) {
                            newState.comments.push("При этом есть поля, похожие на адрес. Попробуйте разобрать адрес и добавить такие признаки.");
                        }
                        else {
                            newState.comments.push("Возможно, они есть, и стоит указать их при настройке структуры набора.");
                        }
                }

        }
        else {
            newState.comments.push("Алгоритм не смог проанализировать этот набор данных и порекомендовать параметры алгоритма. Выберите их вручную.");
        }

        if (newState.version) {
            if (dataset.state.properties.connected) {
                newState.filterOfPart = "not_connected";
            }
            else {
                newState.filterOfPart = "full";
            }
        }

        Object.entries(this.RESULT_QUALITY_GROUPS).forEach((typeArray) => {
            newState[typeArray[0] + "Samples"] = { checkingTreshold: this.RESULT_QUALITY_GROUPS[typeArray[0]].defaultTreshold };
        });
        newState.activeSampleTab = "normal";

        this.setState(
            newState,
            () => {
                if (dataset) {
                    this.setState({ activeProcess: checkActiveProcess(dataset, 'lk_connector') });
                }
                //this.datasetProcessCheck(dataset);
                if (connectionStage === "readyToCheck") {
                    this.getAllCheckingResults();
                }
            }
        );
    }

    getFieldByFeature = (dataset, feature) => {
        let foundField = null;
        if (dataset && dataset.fields) {
            foundField = dataset.fields.find((field) => (field.feature === feature) && ((feature !== "Geometry") || (field.name !== "oarObject.Geometry")));
        }
        return foundField;
    }

    updateAndCheckDataset = (dataset) => {
        // console.log("updateAndCheckDataset")

        if (dataset) {
            // dataset.runningTasks
            //     && dataset.runningTasks.length > 0
            //     && console.log(dataset.runningTasks[0].lastInfo.progress);

            // if (this.props.taskState.state === "running" || this.props.taskState.state === "finish")
            //     this.setState({
            //         dataset: dataset,
            //         connectionStage: 'connections',
            //         activeProcess: checkActiveProcess(dataset, 'lk_connector'),
            //     }, () => this.props.afterUpdate());
            // else {
            let connectionStage = dataset.connect && dataset.connect.stage ? dataset.connect.stage : "newconnection";

            if (connectionStage !== "readyToCheck") {
                let datasets = this.props.datasetsContainer.datasets;
                datasets.forEach((newDataset) => {
                    if (newDataset._id === dataset._id) {
                        let connectionStage = newDataset.connect && newDataset.connect.stage ? newDataset.connect.stage : "newconnection";

                        if (connectionStage === "readyToCheck") {
                            this.getAllCheckingResults();
                        }

                        this.setState({
                            dataset: newDataset,
                            connectionStage: connectionStage,
                            activeProcess: checkActiveProcess(newDataset, 'lk_connector'),
                        });
                    }
                })

            }
            // }
        }
    }

    /*
    datasetProcessCheck = (dataset) => {
        this.checkInterval && clearInterval(this.checkInterval);
        if (dataset) {
            this.checkInterval = setInterval(() => {
                this.startLoading();
                this.updateAndCheckDataset(dataset)
            }, 100);
        }
    }
    */

    handleRegionSelect = (region) => {
        this.setState({
            selectedRegion: region
        });
    }

    onStartProcess = () => {
        if (this.state.dataset &&
            !this.state.onErrorWithProcesses &&
            (((this.state.version === "v5") || (this.state.version === "v6")) || this.state.selectedRegion) &&
            this.state.version &&
            this.state.crossType &&
            this.state.filterOfPart &&
            ((this.state.version === "v7") || (this.state.fieldsForGeocoding.length > 0))
        ) {
            let filter = null;
            if (this.props.filters) {
                filter = this.props.filters;
            } else {
                if (this.state.filterOfPart === "not_connected") {
                    filter = { 'oarObject': null };
                }
            }


            let featuresOption = {};
            this.state.fieldsForGeocoding.forEach(field => {
                featuresOption[field] = field;
            });

            this.setState({ buttonJustPressed: true });

            this.lkApi.lKConnectionTask(
                {},
                this.state.dataset.dataset,
                this.state.selectedRegion ? this.state.selectedRegion.database : null,
                {
                    crossType: this.state.crossType,
                    version: this.state.version,
                    partsName: this.state.partsName,
                    filter: filter,
                    features: featuresOption,
                    detectedRegionName: (this.state.oneRegionValue && this.state.detectedRegionName ? this.state.detectedRegionName : null),
                    detectedMunicipalitetName: (this.state.oneMunicipalitetValue && this.state.detectedMunicipalitetName ? this.state.detectedMunicipalitetName : null)
                }).then((response) => {
                    this.setState({
                        connectionStage: "connections",
                        activeProcess: checkActiveProcess(this.state.dataset, 'lk_connector')
                    });

                    //this.updateAndCheckDataset(this.state.dataset);

                    setTimeout(() => { this.setState({ buttonJustPressed: false }) }, 5000);
                });

        }
    }

    getAllCheckingResults = () => {
        Object.entries(this.RESULT_QUALITY_GROUPS).forEach((typeArray) => {
            this.getCheckingResults(typeArray[0]);
        })
    }

    getCheckingResults = (qualityGroup) => {
        let options = this.RESULT_QUALITY_GROUPS[qualityGroup];

        if (this.state.dataset && this.state.dataset.connect && this.state.dataset.connect.database && this.state.dataset.connect.dataset) {

            let baseFilter = (typeof options.filter === "function" ?
                options.filter(this.state.normalSamples.checkingTreshold, this.state.inaccurateSamples.checkingTreshold, this.state.streetSamples.checkingTreshold) :
                options.filter);

            let aboveFilter = Object.assign({}, baseFilter);
            aboveFilter["__connection." + options.weightField] = { "$gt": this.state[qualityGroup + "Samples"].checkingTreshold };

            let belowFilter = Object.assign({}, baseFilter);
            belowFilter["__connection." + options.weightField] = { "$lte": this.state[qualityGroup + "Samples"].checkingTreshold };



            Promise.all(
                [
                    this.generalApi.getObjects(
                        "userDatasetByToken",
                        this.state.token,
                        {
                            filter: aboveFilter,
                            limit: this.SAMPLES_PORTION_SIZE,
                            skip: 0,
                            sortBy: "__connection." + options.weightField,
                            sortOrder: "asc"
                        }),
                    this.generalApi.getObjectsCount(
                        "userDatasetByToken",
                        this.state.token,
                        {
                            filter: aboveFilter
                        }),
                    this.generalApi.getObjects(
                        "userDatasetByToken",
                        this.state.token,
                        {
                            filter: belowFilter,
                            limit: this.SAMPLES_PORTION_SIZE,
                            skip: 0,
                            sortBy: "__connection." + options.weightField,
                            sortOrder: "desc"
                        }),
                    this.generalApi.getObjectsCount(
                        "userDatasetByToken",
                        this.state.token,
                        {
                            filter: belowFilter
                        }),
                    this.generalApi.getObjects(
                        "userDatasetByToken",
                        this.state.token,
                        {
                            filter: { "__connection": null },
                            limit: 1,
                            skip: 0
                        }
                    ),
                    this.generalApi.getObjectsCount(
                        "userDatasetByToken",
                        this.state.token,
                        {
                            filter: { "__connection": null }

                        }
                    )
                ]).then((responses) => {
                    let above = { objects: responses[0], count: responses[1].count };
                    let below = { objects: responses[2], count: responses[3].count };
                    let empty = { objects: responses[4], count: responses[5].count };

                    if (above && above.objects) {
                        above.objects = above.objects.reverse();
                    }

                    this.setState({
                        [qualityGroup + "Samples"]: Object.assign({},
                            this.state[qualityGroup + "Samples"],
                            {
                                aboveSamples: above,
                                belowSamples: below,
                                emptyCount: empty.count
                            })
                    });
                });
        }
    }

    onApplyResults = () => {
        if (this.state.dataset) {
            let tresholds = {};
            Object.entries(this.RESULT_QUALITY_GROUPS).forEach((typeArray) => {
                tresholds[typeArray[0]] = this.state[typeArray[0] + "Samples"].checkingTreshold;
            });

            this.setState({ buttonJustPressed: true }, () => {
                this.lkApi.applyLKConnectorResults(
                    tresholds,
                    this.state.dataset.dataset
                ).then((response) => {
                    this.startLoading();
                    this.state.dataset.connect.stage = null;
                    this.updateAndCheckDataset(this.state.dataset);
                    setTimeout(() => { this.setState({ buttonJustPressed: false }) }, 5000);
                });
            });
        }
    }

    getSampleInfo = (sample) => {

        let features = this.state.dataset && this.state.dataset.connect && this.state.dataset.connect.features;
        if (!features) {
            features = {
                Municipalitet: "Municipalitet",
                Street: "Street",
                HouseNumber: "HouseNumber",
                Street2: "Street2",
                HouseNumber2: "HouseNumber2"
            }
        }

        let originalFields = [];
        Object.keys(features).forEach(f => {
            originalFields.push(features[f]);
        });


        let sampleInfo = {};
        sampleInfo.weightBlock = sample.__connection[this.RESULT_QUALITY_GROUPS[this.state.activeSampleTab].weightField].toFixed(3);
        sampleInfo.originalAddress = originalFields.map(f => sample[f] || '').join(" ");

        //    [(sample.Municipalitet || ""), (sample.Street || ""), (sample.HouseNumber || "")].join(" ")
        //    + (sample.Street2 && sample.HouseNumber2 ? " / " + sample.Street2 + " " + sample.HouseNumber2 : "");
        sampleInfo.connectedAddress = this.RESULT_QUALITY_GROUPS[this.state.activeSampleTab].connectedAddressFields.map((field) => (sample.__connection[field] || "")).join(" ")
            + (sample.__connection.Street2 && sample.__connection.HouseNumber2 ? " / " + sample.__connection.Street2 + " " + sample.__connection.HouseNumber2 : "");
        if (sample.x && sample.y && sample.__connection.x && sample.__connection.y) {
            let d = Math.sqrt(Math.pow(sample.x - sample.__connection.x, 2) + Math.pow(sample.y - sample.__connection.y, 2));
            sampleInfo.distance = '~ ' + Math.round(d) + ' м';
        }

        return sampleInfo;
    }


    render() {

        if (this.state.dataset && (!this.state.normalSamples)) {
            this.updateAndCheckDataset(this.state.dataset)
        }

        let VERSIONS_SET = {
            //v1: "Версия v1",
            //v2: "Версия v2",
            //v3: "Версия v3",
            //v4: "Версия v4",
            v5: "без нейросети",
            v6: "с нейросетью"
        };

        let CROSS_TYPE_BY_VERSION = {
            v5: "BY_SUPERTAGS",
            v6: "BY_ADDRESS_MATCHING"
        };


        let CROSS_TYPE_SET = {
            BY_CENTERS: "По геометрии и адресу (должны быть координаты!)",
            BY_HIERARHY: "По иерархическим адресам (для аккуратных данных)",
            BY_FULLADDRESS: "По полным адресам (любые данные)"
        };

        let PARTS_NAME_SET = {
            blocks: "По блокам (мун.районы, города)",
            municipalitets: "По населенным пунктам",
            quarters: "По кадастровым кварталам"
        };

        let FILTERS_SET = {
            full: "Весь набор целиком",
            not_connected: "Только несвязанные остатки"
        };


        let activeSamples = this.state[this.state.activeSampleTab + "Samples"];

        let tabs = [];
        Object.entries(this.RESULT_QUALITY_GROUPS).forEach((typeArray) => {
            let samples = this.state[typeArray[0] + "Samples"];
            if (samples && samples.aboveSamples && samples.belowSamples) {
                let count = samples.aboveSamples.count + samples.belowSamples.count;
                if (count > 0) {
                    tabs.push({
                        label: typeArray[1].label + " " + count + ' шт',
                        key: typeArray[0],
                        className: "everyChanger" + (typeArray[0] === this.state.activeSampleTab ? " activeChanger" : ""),
                        onClick: () => { this.setState({ activeSampleTab: typeArray[0] }); }
                    });
                }
            }
        });

        let fieldsForGeocodingCaptions = this.state.fieldsForGeocoding.map(field => {
            return this.state.dataset.fields.find(f => (f.name === field)).caption
        })

        let filterLabels = [];
        if (this.state.dataset && this.props.filters && (Object.entries(this.props.filters).length > 0)) {
            Object.entries(this.props.filters).forEach((fieldName) => {
                this.state.dataset.fields.forEach((field) => {
                    if (field.name === fieldName[0]) {
                        filterLabels.push("поле «" + field.caption + "»: значение «" +
                            (
                                this.props.filters[fieldName[0]] && this.props.filters[fieldName[0]]['$regex'] ?
                                    this.props.filters[fieldName[0]]['$regex'] :
                                    (document.getElementById(`text-filter-column-${fieldName[0]}`).value)
                            )
                            + "»");
                    }
                });
            });
        }

        //console.log(this.state.version, this.state.selectedRegion, this.state.crossType, this.state.filterOfPart);


        return (
            <div className='twoHalfs'>
                <div id={"connector"} className={"flexColumn rightPanel"}>
                    {this.renderAlerts()}

                    <LeftPanelHeader
                        dataset={this.state.dataset}
                        sectionName={this.sectionName(actionTypes.CONNECTOR)}
                    />

                    <div className="postHeaderContainer textRoboto infoContainer">

                        {(this.state.connectionStage === "connections") &&
                            <div>
                                {this.props.progressBar}
                                {this.state.activeProcess && this.state.activeProcess.lastInfo && this.state.activeProcess.lastInfo.errors && this.state.activeProcess.lastInfo.errors.length > 0 &&
                                    <p>{this.state.activeProcess.lastInfo.errors.join(" ")}</p>
                                }
                            </div>
                        }

                        {(this.state.connectionStage === "readyToCheck") && (activeSamples) && (activeSamples.aboveSamples) && (activeSamples.belowSamples) &&
                            <div className="infoProcesses2">
                                <p className="textHint">Ранее запущенное связывание набора с ОАП - почти готово!</p>
                                <p className="textHint">Сейчас следует выборочно проверить результаты и выбрать пороговое значение веса.</p>
                                <p className="textHint">Связи с весом выше выбранного будут добавлены к набору данных. Остальные связи, возможно, будут менее точными - до улицы или населенного пункта.</p>

                                <div className="tabsChanger">
                                    {tabs.map((tab) => (
                                        <p className={tab.className} key={tab.key} onClick={tab.onClick}>{tab.label}</p>
                                    ))}
                                </div>

                                <div className={'tresholdSlider'}>
                                    <RangeSlider
                                        min={0}
                                        max={1}
                                        step={0.001}
                                        value={activeSamples.checkingTreshold}
                                        onChange={(e) => {
                                            let newState = {};
                                            newState[this.state.activeSampleTab + "Samples"] = this.state[this.state.activeSampleTab + "Samples"];
                                            newState[this.state.activeSampleTab + "Samples"].checkingTreshold = Number.parseFloat(e.target.value);
                                            this.setState(newState);
                                        }}
                                        onAfterChange={() => {
                                            this.getAllCheckingResults();
                                            //this.getCheckingResults(this.state.activeSampleTab); 
                                        }}
                                    />
                                </div>

                                <p>При пороговом значении {activeSamples.checkingTreshold.toFixed(3)} применятся {activeSamples.aboveSamples.count} и не применятся {activeSamples.belowSamples.count} связей{(activeSamples.emptyCount > 0) && (this.state.activeSampleTab === "normal") ? ", а еще " + activeSamples.emptyCount + " не имеют связей вовсе." : "."}</p>
                                <div className="fullPanel">

                                    {activeSamples.aboveSamples.objects &&
                                        <div className="halfPanel">
                                            {(activeSamples.aboveSamples.objects.length === 0) &&
                                                <p>все веса связей ниже выбранного порога</p>
                                            }
                                            {activeSamples.aboveSamples.objects.map((sample, index) => {
                                                let sampleInfo = this.getSampleInfo(sample);

                                                return <div className="resultItem aboveResults" key={index}>
                                                    <p className="weightBlock">{sampleInfo.weightBlock}</p>
                                                    {sampleInfo.distance &&
                                                        <p className="distanceBlock">{sampleInfo.distance}</p>
                                                    }
                                                    <div className="addresses">
                                                        <p className="originalAddress">{sampleInfo.originalAddress}</p>
                                                        <p className="connectedAddress">{sampleInfo.connectedAddress}</p>
                                                    </div>
                                                </div>
                                            }
                                            )}
                                        </div>
                                    }

                                    {activeSamples.belowSamples.objects &&
                                        <div className="halfPanel">
                                            {(activeSamples.belowSamples.objects.length === 0) &&
                                                <p>все веса связей выше выбранного порога</p>
                                            }
                                            {activeSamples.belowSamples.objects.map((sample, index) => {
                                                let sampleInfo = this.getSampleInfo(sample);

                                                return <div className="resultItem belowResults" key={index}>
                                                    <p className="weightBlock">{sampleInfo.weightBlock}</p>
                                                    {sampleInfo.distance &&
                                                        <p className="distanceBlock">{sampleInfo.distance}</p>
                                                    }
                                                    <div className="addresses">
                                                        <p className="originalAddress">{sampleInfo.originalAddress}</p>
                                                        <p className="connectedAddress">{sampleInfo.connectedAddress}</p>
                                                    </div>
                                                </div>
                                            }
                                            )}
                                        </div>
                                    }
                                </div>

                                <Button className='applyInstrument' style={this.state.buttonJustPressed ? { opacity: '0.3', pointerEvents: 'none' } : { opacity: '1' }} onClick={this.onApplyResults}>Применить результаты</Button>

                            </div>
                        }

                        {((this.state.connectionStage === "newconnection") || (this.state.connectionStage === "failed")) &&
                            <div style={{ overflow: 'auto', minHeight: '500px' }}>
                                {(this.state.connectionStage === "failed") &&
                                    <p className="textError">Прошлая попытка связывания завершилась ошибкой. Попробуйте еще раз.</p>
                                }

                                {this.state.comments && this.state.comments.map((comment, index) => (
                                    <p className="textHint" key={index}>{comment}</p>
                                ))}

                                {(filterLabels.length > 0) ?
                                    <div>
                                        <p className="textHint">Связываться будут {this.props.count} записей, поскольку выбраны фильтры:</p>
                                        {filterLabels.map((label, i) => (
                                            <p className="textHint" key={'textHintMap' + i}>- {label}</p>
                                        ))}
                                    </div>
                                    :
                                    (
                                        (this.state.filterOfPart === "not_connected") ?
                                            <p className="textHint">{"Набор данных уже связывался ранее, " + Math.round(this.state.dataset.state.fieldsQuality.oarObject.fullness * 100) + "% записей - успешно. Сейчас будут связываться остатки."}</p>
                                            :
                                            <p className="textHint">Связываться будет весь набор. Если нужно, выберите фильтрами колонок какую-то часть данных.</p>
                                    )
                                }


                                {((this.state.version === "v5") || (this.state.version === "v6")) &&
                                    <div>
                                        <p className="textBottom">Поля для геокодирования</p>
                                        <div className="twoColumns">
                                            <div className="">

                                                <div>
                                                    {(this.state.fieldsForGeocoding.length === 0) &&
                                                        <p className="textHint">выберите хотя бы одно</p>
                                                    }
                                                    {(this.state.fieldsForGeocoding.length > 0) &&
                                                        <ul>
                                                            {fieldsForGeocodingCaptions.map((field, index) => (
                                                                <li className="textHint" key={field}>{field}  <span className="removeButton" onClick={() => {
                                                                    let lost = [...this.state.fieldsForGeocoding];
                                                                    lost.splice(index, 1);
                                                                    this.setState({ fieldsForGeocoding: lost })
                                                                }}>[x]</span></li>
                                                            ))}
                                                        </ul>
                                                    }
                                                </div>
                                                <DropdownWithFilter
                                                    className="dropConnector"
                                                    items={this.state.dataset.fields.filter(f => (this.state.fieldsForGeocoding.indexOf(f.name) < 0))}
                                                    selectedItem={null}
                                                    onItemClick={(item) => {
                                                        let newFields = [...this.state.fieldsForGeocoding, item.name];
                                                        this.setState({ fieldsForGeocoding: newFields })
                                                    }}
                                                    label={(item) => { return item.caption || "(не установлено)"; }}
                                                    defaultLabel={"добавьте"}
                                                />

                                                <p className="textBottom">Версия алгоритма</p>
                                                <Dropdown className="dropConnector dropConnectorInline">
                                                    <Dropdown.Toggle className="dropdownButtonConnector" variant="success" id="dropdown-basic">
                                                        {this.state.version ? <p className='dropdown-item'>{VERSIONS_SET[this.state.version]}</p> : "Выберите"}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {Object.entries(VERSIONS_SET).map((typeArray, index2) => (
                                                            <Dropdown.Item className='dropdown-item' key={index2} onClick={() => {
                                                                this.setState({
                                                                    version: typeArray[0],
                                                                    crossType: CROSS_TYPE_BY_VERSION[typeArray[0]]
                                                                });
                                                            }} data-tooltip-id={typeArray[1].length > 28 && "my-tooltip"} data-tooltip-content={typeArray[1].length > 25 && typeArray[1]}>{typeArray[1]}</Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {this.state.regionState &&
                                    <>
                                        {this.state.version &&
                                            <div>
                                                <p className="textBottom">Регион для связывания</p>
                                                <DropdownWithFilter
                                                    className="dropConnector"
                                                    items={this.state.regionState}
                                                    selectedItem={this.state.selectedRegion}
                                                    onItemClick={(item) => { this.handleRegionSelect(item) }}
                                                    label={(item) => { return item.region || "(не установлено)"; }}
                                                    defaultLabel={"Выберите"}
                                                />
                                                {!this.state.selectedRegion &&
                                                    <p className="textHint">Не удалось автоматически угадать регион, выберите этот параметр вручную</p>
                                                }
                                            </div>
                                        }
                                    </>
                                }

                                {(this.state.processResult)
                                    ?
                                    <div className='textBottom'>
                                        {(this.state.processResult.status === "success")
                                            ?
                                            <div>
                                                <p className='textBottom'>Запущен процесс связывания</p>
                                            </div>
                                            :
                                            <p className='textBottom'>Произошла ошибка: {this.state.processResult.errorMessageRu}</p>
                                        }
                                    </div>
                                    :
                                    (this.state.dataset &&
                                        (((this.state.version === "v5") || (this.state.version === "v6")) || this.state.selectedRegion) &&
                                        this.state.version &&
                                        this.state.crossType &&
                                        this.state.filterOfPart &&
                                        ((this.state.version === "v7") || (this.state.fieldsForGeocoding.length > 0)) &&
                                        <Button className='applyInstrument' style={this.state.buttonJustPressed ? { opacity: '0.3', pointerEvents: 'none' } : { opacity: '1' }} onClick={this.onStartProcess}>Запустить связывание</Button>
                                    )
                                }

                                {this.state.version &&
                                    <div className="dropConnectorInlineBlock">
                                        <p className="textHint">Если очень хочется, можете поменять автоматически выбранные параметры алгоритма.</p>
                                        <p className="textHint">Эта возможность позже будет отключена.</p>

                                        <p className="textBottom">Версия алгоритма</p>
                                        <Dropdown className="dropConnector dropConnectorInline">
                                            <Dropdown.Toggle className="dropdownButtonConnector" variant="success" id="dropdown-basic">
                                                {this.state.version ? <p className='dropdown-item'>{VERSIONS_SET[this.state.version]}</p> : "Выберите"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {Object.entries(VERSIONS_SET).map((typeArray, index2) => (
                                                    <Dropdown.Item className='dropdown-item' key={index2} onClick={() => {
                                                        this.setState({ version: typeArray[0] });
                                                    }} data-tooltip-id={typeArray[1].length > 28 && "my-tooltip"} data-tooltip-content={typeArray[1].length > 25 && typeArray[1]}>{typeArray[1]}</Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        <p className="textBottom">Способ связывания</p>
                                        <Dropdown className="dropConnector dropConnectorInline">
                                            <Dropdown.Toggle className="dropdownButtonConnector" variant="success" id="dropdown-basic">
                                                {this.state.crossType ? <p className='dropdown-item'>{CROSS_TYPE_SET[this.state.crossType]}</p> : "Выберите"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {Object.entries(CROSS_TYPE_SET).map((typeArray, index2) => (
                                                    <Dropdown.Item className='dropdown-item' key={index2} onClick={() => {
                                                        this.setState({ crossType: typeArray[0] });
                                                    }} data-tooltip-id={typeArray[1].length > 28 && "my-tooltip"} data-tooltip-content={typeArray[1].length > 25 && typeArray[1]}>{typeArray[1]}</Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        <p className="textBottom">Способ дробления территории</p>
                                        <Dropdown className="dropConnector dropConnectorInline">
                                            <Dropdown.Toggle className="dropdownButtonConnector" variant="success" id="dropdown-basic">
                                                {this.state.partsName ? <p className='dropdown-item'>{PARTS_NAME_SET[this.state.partsName]}</p> : "Выберите"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {Object.entries(PARTS_NAME_SET).map((typeArray, index2) => (
                                                    <Dropdown.Item className='dropdown-item' key={index2} onClick={() => {
                                                        this.setState({ partsName: typeArray[0] });
                                                    }} data-tooltip-id={typeArray[1].length > 28 && "my-tooltip"} data-tooltip-content={typeArray[1].length > 25 && typeArray[1]}>{typeArray[1]}</Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        <p className="textBottom">Часть набора для связывания</p>
                                        <Dropdown className="dropConnector dropConnectorInline">
                                            <Dropdown.Toggle className="dropdownButtonConnector" variant="success" id="dropdown-basic">
                                                {this.state.filterOfPart ? <p className='dropdown-item'>{FILTERS_SET[this.state.filterOfPart]}</p> : "Выберите"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {Object.entries(FILTERS_SET).map((typeArray, index2) => (
                                                    <Dropdown.Item className='dropdown-item' key={index2} onClick={() => {
                                                        this.setState({ filterOfPart: typeArray[0] });
                                                    }} data-tooltip-id={typeArray[1].length > 28 && "my-tooltip"} data-tooltip-content={typeArray[1].length > 25 && typeArray[1]}>{typeArray[1]}</Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                }
                            </div>
                        }
                    </div>


                </div>

                <div className='rightHalf'></div>

                <Tooltip id="my-tooltip" place='right' onClick={() => this.props.clearTaskState()} />

            </div>
        );
    }
}